import { v4 as uuidv4 } from "uuid";
import React from "react";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListenerRule from "./ListenerRule";
import {
  faChevronDown,
  faChevronUp,
  faMinusCircle,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useConfirmDialog } from "../../Components/ConfirmDialogContext";

export default function ListenerRules({
  listenerRules,
  setListenerRules,
  event,
}) {
  const confirmDialog = useConfirmDialog();
  const state =
    [...(listenerRules || [])]?.sort((a, b) => a.Order - b.Order) ?? [];
  const dispatch = (action) => {
    switch (action.type) {
      case "update-rule":
        setListenerRules(
          state.map((rule, Order) => {
            if (rule.UUID === action.ruleId) {
              if (!action.data.Conditions?.length) {
                return { ...action.data, Order, CatchAll: true };
              }
              return { ...action.data, Order, CatchAll: false };
            }
            return { ...rule, Order };
          })
        );
        break;
      case "rule-add":
        {
          const uniqueId = uuidv4();
          setListenerRules(
            [
              ...state,
              {
                UUID: uniqueId,
                Label: `Rule-${uniqueId.slice(0, 4)}`,
                Conditions: [],
                Actions: [],
              },
            ].map((rule, Order) => ({ ...rule, Order }))
          );
        }
        break;
      case "rule-remove":
        setListenerRules(
          state
            .filter((r) => action.ruleUUID !== r.UUID)
            .map((rule, Order) => ({ ...rule, Order }))
        );
        break;
      case "rule-up":
        {
          const rules = state;
          const [rule] = rules.splice(action.index, 1);
          rules.splice(action.index - 1, 0, rule);
          setListenerRules(rules.map((r, Order) => ({ ...r, Order })));
        }
        break;
      case "rule-down":
        {
          const rules = state;
          const [rule] = rules.splice(action.index, 1);
          rules.splice(action.index + 1, 0, rule);
          setListenerRules(rules.map((r, Order) => ({ ...r, Order })));
        }
        break;
      default:
    }
  };

  const handleRemoveRule = async (rule) => {
    // check for a connected port
    if (
      state
        .find((c) => rule.UUID === c.UUID)
        .Actions?.find((a) => a.Type === "start:runtime" && a.TypeUUID)
    ) {
      toast.error(
        "Port is connected. Rule can not be removed. Disconnect port first."
      );
      return;
    }

    if (
      (await confirmDialog(
        "Remove rule",
        `Are you sure you want to remove this rule: "${rule.Label}"?`
      )) === false
    ) {
      return;
    }
    dispatch({ type: "rule-remove", ruleUUID: rule.UUID });
  };

  return (
    state && (
      <div className="mt-2">
        <h3>
          Rules:
          <button
            type="button"
            title="Add rule"
            disabled={state.find((rule) => !rule.Conditions?.length)}
            className="btn btn-outline-primary border-0 ms-2 btn-sm float-end"
            onClick={() => dispatch({ type: "rule-add" })}
          >
            <FontAwesomeIcon icon={faPlusCircle} /> Add Rule
          </button>
        </h3>
        {state.length > 0 ? (
          state.map((rule, index) => (
            <div className="mt-1 card" key={rule.UUID}>
              <div className="card-header">
                {index > 0 && "Else"}{" "}
                {rule.Conditions?.length > 0 ? "If" : "Catch all"}
                <button
                  type="button"
                  title="Remove rule"
                  className="btn btn-outline-danger btn-sm float-end border-0"
                  onClick={() => handleRemoveRule(rule)}
                >
                  <FontAwesomeIcon icon={faMinusCircle} />
                </button>
              </div>
              <div className="card-body d-flex">
                <div className="flex-grow-1 handler-rule">
                  <ListenerRule
                    event={event}
                    ruleState={rule}
                    setRule={(data) =>
                      dispatch({ type: "update-rule", ruleId: rule.UUID, data })
                    }
                  />
                </div>
                <div className="d-flex flex-column">
                  {index > 0 && (
                    <button
                      type="button"
                      title="Move up"
                      className="btn btn-outline-primary btn-sm border-0"
                      onClick={() =>
                        dispatch({
                          type: "rule-up",
                          ruleId: rule.UUID,
                          index,
                        })
                      }
                    >
                      <FontAwesomeIcon icon={faChevronUp} />
                    </button>
                  )}
                  {index < state.length - 1 && (
                    <button
                      type="button"
                      title="Move down"
                      className="btn btn-outline-primary btn-sm border-0"
                      onClick={() =>
                        dispatch({
                          type: "rule-down",
                          ruleId: rule.UUID,
                          index,
                        })
                      }
                    >
                      <FontAwesomeIcon icon={faChevronDown} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div>No Rules set for this listener. Please add a rule.</div>
        )}
        <div className="row">
          <div className="col-11 col-offset-1" />
        </div>
      </div>
    )
  );
  // );
}
